import LabeledValue from '../../../components/common/LabeledValue';

export interface RetractionSummaryProps {
  approvedOn: string;
  approver: string;
  approverComments: string;
}

export const RetractionSummary: React.FC<RetractionSummaryProps> = ({ approvedOn, approver, approverComments }) => (
  <>
    <div className="mb-4">
      <LabeledValue label="Approved On" value={approvedOn} />
    </div>
    <div className="mb-4">
      <LabeledValue label="Authorized Approver" value={approver} />
    </div>
    <div className="mb-4">
      <LabeledValue label="Approver Comments" value={approverComments} />
    </div>
  </>
);

export interface PartialRetractionSummaryProps {
  submittedOn: string;
  submittedBy: string;
  requestId: string;
  comment: string;
}

export const PartialRetractionSummary: React.FC<PartialRetractionSummaryProps> = ({ submittedOn, submittedBy, requestId, comment }) => (
  <>
    <div className="mb-4">
      <LabeledValue label="Partial Retraction Submitted on" value={submittedOn} />
    </div>
    <div className="mb-4">
      <LabeledValue label="Submitted By" value={submittedBy} />
    </div>
    <div className="mb-4">
      <LabeledValue label="Original Time Off Request ID" value={requestId} />
    </div>
    <div className="mb-4">
      <LabeledValue label="Employee Comment Regarding Retraction" value={comment || 'Comment content goes here.'} />
    </div>
  </>
);
